// ApplyButton.js
import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import useStyles from './style';

// Always rendered inside <Form>, so it submits the form: the browser runs the
// `required` checks first and Form's onSubmit calls the screen's handler once.
const ApplyButton = ({ text, disabled, loading }) => {
  const classes = useStyles();

  return (
    <button type="submit" className={`${classes.button} ${disabled ? classes.disabled : ''}`} disabled={disabled || loading}>
      {loading ? (
        <CircularProgress size={24} color="inherit" /> // Render loader while loading is true
      ) : (
        <span className={classes.text}>{text}</span> // Render button text when not loading
      )}
    </button>
  );
};

ApplyButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool.isRequired, // Add loading prop to indicate loading state
};

ApplyButton.defaultProps = {
  disabled: false,
  loading: false, // Default loading state is false
};

export default ApplyButton;
